module.exports = __webpack_public_path__ + "static/img/zz.56ef55e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audit/zz.png
// module id = BpiK
// module chunks = 1